import React from "react";
import Label from "../label";
import MessageError from "../../message/__errors";
import "../styles.css";

// Числовое поле. value === 0 — валидное значение, не сбрасываем в ''.
export default function InputNumber({ value = '', children, placeholder, errors, className = '', hasLabel = true, ...other }) {
    if (placeholder === undefined) placeholder = children;
    return <>
        {hasLabel ? <Label>{children}</Label> : null}
        <input
            {...other}
            type="number"
            value={(value === null || value === undefined) ? '' : value}
            className={`input ${className}`}
            placeholder={placeholder}
        />
        {errors ? <MessageError errors={errors}/> : null}
    </>;
}
